import { render } from "./Accessory.vue?vue&type=template&id=b424097e&scoped=true"
import script from "./Accessory.vue?vue&type=script&lang=js"
export * from "./Accessory.vue?vue&type=script&lang=js"

import "./Accessory.vue?vue&type=style&index=0&id=b424097e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b424097e"]])

export default __exports__